var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('order-summary',{attrs:{"orderLines":_vm.order.orderLines,"totalByCurrencies":_vm.totalByCurrencies,"currencies":_vm.currencies,"isPaid":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }